import { BudgetTransferTemplate } from "@/modules/template/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const BudgetTransferTemplatePage = ({ isEdit }: IOperationPageProps) => (
  <BudgetTransferTemplate isEdit={isEdit}/>
);
